"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.masseyGlobalColors = void 0;
exports.masseyGlobalColors = {
    primary: {
        brand: '#C71121',
        white: '#FFFFFF',
        black: '#000002',
        grays: {
            200: '#EEEEEE',
            400: '#AFAFB0',
            600: '#6F7072',
            800: '#343434',
        },
    },
    secondary: {
        brand: '#98222A',
        shades: {
            200: '#E5C0C4',
            400: '#DE959B',
            600: '#D56872',
            800: '#CE3D49',
        },
    },
};
